<template>
  <div class="head-box">
    <div class="wrapper">
      <div class="head">
        <span>{{ title }}</span>
      </div>
      <div class="right-box">
        <slot name="btn-list"></slot>
        <el-button class="back-btn" @click="back()" v-if="showBack">返回</el-button>
      </div>
    </div>
    <div class="info-box" v-if="showInfo">
      <slot></slot>
    </div>
  </div>
  
</template>

<script>
export default {
  components: {},
  props: ["title","showBack"],
  data() {
    return {
      showInfo:false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    back() {
      history.go(-1);
    },
  },
  created() {
    if(this.$slots.default&&this.$slots.default.length){
      this.showInfo = true;
    }else{
      this.showInfo = false;
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.head-box {
  .wrapper {
    background: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid #ececec;
    padding: 0 30px;
    .head {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333333;
      font-family: PingFang SC;
      background: #ffffff;
      @media screen and(min-width: 1680px) {
        height: 60px;
        font-size: 20px;
        line-height: 28px;
      }
      @media screen and(max-width: 1680px) {
        height: 50px;
        font-size: 20px;
        line-height: 28px;
      }
    }
    .right-box {
      display: flex;
      .org-btn {
        min-width: 70px;
        width: auto;
        padding: 0 15px;
      }
      .el-button {
        height: 32px;
      }
      .back-btn{
        width: 80px;
        height: 30px;
        background: #FD9E01;
        border: 1px solid #FD9E01;
        color: #ffffff !important;
        padding: 0;
        font-size: 14px;
        
        &:hover{
          opacity: 0.9;
        }
      }
    }
  }
  .info-box {
    background: #F7F7F7;
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    font-size: 14px;
    color: #333333;
    margin: 15px 30px 0;
    width: calc(100% - 60px);
    img {
        margin-right: 10px;
    }
  }
}

</style>